module.exports = __webpack_public_path__ + "img/guida.7079d09d.png";